import { useState } from "react";
import { createContext, useContext } from "react";
import { projects } from "./projects_data";

const AppContext = createContext();

export const StateProvider = ({ children }) => {
    const [theme, setTheme] = useState("dark");
    const [activeLink, setActiveLink] = useState("home");

    const goToTop = (nextLink) => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        setActiveLink(nextLink);
    };

    const toggleTheme = () => {
        const root = document.querySelector(":root");

        if (theme === "dark") {
            setTheme("light");
            root.style.setProperty("--white", "#213848");
            root.style.setProperty("--black", "#f7ad19");

            root.style.setProperty("--bg-1", "#ece2bf");
            root.style.setProperty("--bg-2", "#fbfaf4");
            root.style.setProperty("--bg-3", "#e2d49f");
            root.style.setProperty("--shadow", "#9c8463");
            root.style.setProperty("--typing", "#eb9f09");

            root.style.setProperty("--text-1", "#113537");
            root.style.setProperty("--text-2", "#f7ad19");
            root.style.setProperty("--text-3", "#128ea5");

            root.style.setProperty("--text-head", "#eb9f09");
        } else {
            setTheme("dark");
            root.style.setProperty("--white", "#ffffff");
            root.style.setProperty("--black", "#000000");

            root.style.setProperty("--bg-1", "#021925");
            root.style.setProperty("--bg-2", "#053f5c");
            root.style.setProperty("--bg-3", "#010f17");
            root.style.setProperty("--shadow", "#010f17");

            root.style.setProperty("--typing", "#f7ad19");

            root.style.setProperty("--text-1", "#EAF2E3");
            root.style.setProperty("--text-2", "#f7ad19");
            root.style.setProperty("--text-3", "#128ea5");

            root.style.setProperty("--text-head", "#eb9f09");
        }
    };

    const state = {
        theme,
        toggleTheme,
        activeLink,
        setActiveLink,
        projects,
        goToTop,
    };
    return (
        <AppContext.Provider value={{ ...state }}>
            {children}
        </AppContext.Provider>
    );
};

export const useGlobalContext = () => {
    return useContext(AppContext);
};
